"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
require("./RadioButton.css");
var RadioGroup = /** @class */ (function (_super) {
    __extends(RadioGroup, _super);
    function RadioGroup() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RadioGroup.prototype._getFieldSetProps = function () {
        var _a = this.props, id = _a.id, isEnabled = _a.isEnabled, style = _a.style, tag = _a.tag, errorMessage = _a.errorMessage;
        var groupClasses = ['p-radio-group', style];
        if (errorMessage) {
            groupClasses.push('is-invalid');
        }
        return {
            id: id,
            className: groupClasses.join(' '),
            disabled: !isEnabled,
            'data-tag': tag,
            role: 'radiogroup'
        };
    };
    RadioGroup.prototype.render = function () {
        var _a = this.props, legend = _a.legend, children = _a.children, errorMessage = _a.errorMessage, isRequired = _a.isRequired;
        return (React.createElement("div", null,
            React.createElement("fieldset", __assign({}, this._getFieldSetProps(), { "aria-required": isRequired }),
                legend && React.createElement("legend", null,
                    legend,
                    (isRequired) && React.createElement("span", { className: "p-t-error50" }, "*")),
                children),
            errorMessage && React.createElement("p", { className: "error p-t-error50" }, errorMessage)));
    };
    return RadioGroup;
}(React.Component));
exports.default = RadioGroup;
//# sourceMappingURL=RadioGroup.js.map


//////////////////
// WEBPACK FOOTER
// ../player-radio-button/build/control/RadioGroup.js
// module id = 592
// module chunks = 0